export const environment = {
  isProd:false,
  apiUrl: 'https://cms.dev.website.sheba.gov.il',
  cmsBase: 'https://cms.dev.website.sheba.gov.il',
  baseMedia: 'https://cms.dev.website.sheba.gov.il',
  clientUrl: '',
  soundCloudUrl: 'https://w.soundcloud.com/player?url={{URL}}&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true',
  languageConfiguration: {
    defaultLanguageIsoCode: 'he',
    languageStorageUrl: ''
  },
  recaptcha: {
    siteKey: '6Le56yoqAAAAAHuBIBaTpoPrITiT-g7UO48DfVip'
  },
  googleTagManagerId: 'GTM-P5L9Q2N8',
  appointmentRequestUrl: "https://www.requestForPunch.com",
  phonePrefixes: ['050', '051', '052', '053', '054', '055', '057', '058', '02', '03', '04', '08', '09', '072', '073', '074', '076', '077', '079'],
  previewKey: 'Sheba-Preview',
  customLobbyContainerBreadcrumbs: {
    "he": "לובי רופאים",
    "en": "doctor lobby"
  },
  navigationPaths: {
    DOCTORS_LOBBY: '/lobbies-container/doctors-lobby/',
    HOME: '/'
  },
  elasticsearch: {
    indexes: {
      job: 'job_index',
      labTest: 'lab_test_index',
      internalDepartment: 'internal_department_index',
      doctor: 'doctor_index',
      contentPage :"content_page_index",
      event: "event_index",
      generalContent: "general_content_index",
      phoneIndex: 'phone_index',
      internalDepartmentIndex: 'internal_department_index',
      doctorShebaIndex: 'doctor_sheba_index'
    },
    typeKeywordBoosts: [
      { name: 'לובי בית חולים ', boost: 10 },
      { name: 'דף רופא', boost: 1 },
      { name: 'דף מכון', boost: 5 },
      { name: 'דף תוכן 3', boost: 1 },
      { name: 'דף מכונים', boost: 5 },
      { name: 'דף תוכן 1', boost: 1 },
      { name: 'דף חדשות', boost: 1 },
      { name: 'דף אירוע ', boost: 1 },
      { name: 'Hotel Page', boost: 1 },
      { name: '3 דף תוכן', boost: 1 },
      { name: 'Article ', boost: 1 },
      { name: 'NON-Doctor Page Type', boost: 1 },
      { name: 'דף סרטון', boost: 1 },
      { name: 'Doctor Page', boost: 1 },
      { name: 'Index page', boost: 1 },
    ]
  },
  cookieConsentDialog:"https://csm-dev.website.sheba.gov.il/media/hgoo431r/privacy.pdf",
  // TEMPORARY: List of text to exclude from lobby filters - TODO: Remove this later
 lobbyFilterExcludeList: ['כללי','general','общий','عام'],
 oldSiteAr:"",
 oldSiteRu:""
};
